module.exports = __webpack_public_path__ + "static/media/event-without-views.5de92749.svg";